<template>
  <div class="clazz_btn">
    <!-- <div class="contract" @click="contractHandler">
      <van-icon class="icon" name="chat-o" />
      <span>联系班长</span>
    </div> -->
    <!-- <div class="share" @click="shareHandler">
      <van-icon class="icon" name="share" />
      <span>分享</span>
    </div> -->
    <div v-if="username">
      <div v-if="check.status==2" class="btn disabled">已报名赛事</div>
      <div v-if="check.status==0" class="btn" @click="gotoEnrollShow">立即报名</div>
      <div v-if="check.status==1" class="btn disabled">报名已结束</div>
      <div v-if="check.status==3" class="btn disabled">报名未开始</div>
    </div>
    <div v-else class="btn" @click="gotoLogin">立即报名</div>
  </div>
</template>

<script>
import { setRedirect } from '@/utils/index'
import { mapGetters } from 'vuex'
import { Icon, Dialog } from 'vant'

export default {
  name: 'RaceBtn',
  components: {
    [Icon.name]: Icon,
    [Dialog.name]: Dialog
  },
  props: {
    race: {
      type: Object
    },
    check: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters([
      'username',
      'userprofile'
    ])
  },
  created () {
    console.log(this.check)
  },
  methods: {
    gotoLogin () {
      setRedirect(this.$route.fullPath)
      if (process.env.NODE_ENV === 'development') {
        this.$router.push(`/login?redirect=${this.$route.fullPath}`)
      } else {
        this.$router.push(`/author?redirect=${this.$route.fullPath}`)
      }
    },
    gotoEnrollShow () {
      if (!this.userprofile.is_bind_mobile) {
        this.$router.push('/bind/mobile?path=' + encodeURIComponent(this.$route.fullPath))
        return
      }
      this.$parent.fatherMethod()
      // this.$router.push('/race_order/' + this.race.id + '/confirm')
      // this.$router.push('/clazz/' + this.clazz.uuid + '/enroll/show')
    },
    gotoJoinRace () {
      this.$router.push('/join/clazz/' + this.race.id)
    },
    contractHandler () {
      this.$emit('contract')
    },
    shareHandler () {
      this.$router.push(`/clazz/poster?clazz_id=${this.clazz.uuid}`)
      // this.$emit('share')
    },
    gotoHome () {
      this.$router.push('/')
    }
  }
}
</script>

<style scoped lang="scss">
.clazz_btn {
  position: fixed;
  bottom: 0;
  max-width: 750PX;
  width: 750px;
  height: 100px;
  font-size: 28px;
  // display: flex;
  // justify-content: center;
  // align-items: center;
  // border-top: 1PX solid #eef0f3;
  // background-color: #fff;
  // .home,
  // .contract,
  // .share {
  //   height: 80px;
  //   display: flex;
  //   flex-direction: column;
  //   justify-content: flex-end;
  //   align-items: center;
  //   .icon {
  //     font-size: 30px;
  //     margin-bottom: 5px;
  //   }
  //   span {
  //     font-size: 22px;
  //   }
  // }
  // .home {
  //   width: 80px;
  // }
  // .contract {
  //   width: 120px;
  // }
  // .share {
  //   width: 100px;
  // }
  .btn {
    // width: 570px;
    width: 750px;
    height: 100px;
    // margin-left: 20px;
    // margin-right: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f5222d;
    color: #fff;
    // border-radius: 10px;
    &.disabled {
      background-color: #f89ba0;
      color: #f8f8f8;
    }
  }
}
</style>
